import React, {useEffect } from 'react';
import { createStyles, makeStyles} from '@material-ui/core';
import StringFormat from '../../utils/StringFormatUtil'

export type CountUpProps = {
    date: Date;
    showSeconds?: boolean;
};

const useStyles = makeStyles(() =>
    createStyles({
        root: {
            margin: '10px',
        },
    })
);
const CountUp: React.FC<CountUpProps> = ({
    date,
    showSeconds = false
}) => {

    const classes = useStyles();

    let horas:number = 0, minutos:number = 0, segundos:number = 0;

    const [timerDisplay, setTimerDisplay] = React.useState("00:00:00");

    useEffect(() => {
        initial();     

        var miliseconds = 1000 * (showSeconds? 1 : 60);

        let interval:any;

        if(showSeconds)
            interval = setInterval(iterarSegundos, miliseconds);
        else
            interval = setInterval(iterarMinutos, miliseconds);

        return () => clearTimeout(interval);  
    }, []);


    function initial()
    {
        const dataAtual = new Date(Date.now());
        const dataEntrada = new Date(date);

        var diffMs = dataAtual.getTime() - dataEntrada.getTime();

        //             sec    Min  Hr   Day
        // 86400000 = 10000 * 60 * 60 * 24
        let days =  Math.floor(diffMs / 86400000)

        let hours = Math.floor((diffMs % 86400000) / 3600000)

        let minuts = Math.floor(((diffMs % 86400000) % 3600000) / 60000)

        let seconds = Math.floor(60 * (Number(String((((diffMs % 86400000) % 3600000) % 60000)).substring(0, 2)) / 100))

        horas = hours + (days * 24);
        minutos = minuts;
        segundos = seconds;

        setTimerDisplay(makeDisplay());
    }


    function iterarSegundos()
    {
        var sec:number = segundos;

        sec = (sec+1);
   
        if(sec >= 60)
        {
            segundos = 0;
            iterarMinutos();
        }
        else
        {
            segundos = sec;
            setTimerDisplay(makeDisplay());
        }
    }

    function iterarMinutos()
    {
        var min:number = minutos;

        min = (min+1);

        if(min >= 60)
        {
            minutos = 0;
            iterarHoras();
        }
        else
        {
            minutos = min;
            setTimerDisplay(makeDisplay());
        }
    }

    function iterarHoras()
    {
        horas = horas+1;
        setTimerDisplay(makeDisplay());
    }

    function makeDisplay()
    {
        var text = `${horas}:${StringFormat.pad(minutos,2)}`
        
        if (showSeconds)
            text += `:${StringFormat.pad(segundos,2)}`

        return text;
    }
    
    return (       
            <span >{timerDisplay}</span>
    );
};

export default React.memo(CountUp);